import { env } from '../env';
import { navegarEAguardarSaida } from '../location';
import { createOldSiteRedirectUrl } from '../migration/old-site';

/**
 * O login da Área da Revenda acontece na tela do Autenticador (fluxo Authorization Code).
 * Quem inicia e conclui o fluxo é a API, então aqui só montamos as urls e mandamos o
 * navegador para elas.
 *
 * O `redirect` é o caminho do site novo para onde voltar depois do login. A API o coloca
 * no `state` do Authorization Code e o devolve no callback — é assim que o usuário cai na
 * rota que tentou acessar em vez do dashboard.
 */
export function criarUrlLogin(redirect?: string) {
  const url = criarUrlApi('auth/authorize');

  if (redirect) {
    url.searchParams.set('redirect', redirect);
  }

  return url.toString();
}

/**
 * Endpoint da API que encerra a sessão da Área da Revenda e também a do Autenticador.
 */
export function criarUrlLogout() {
  return criarUrlApi('auth/logout').toString();
}

export function redirecionarParaLogin({
  replace = false,
  redirect,
}: { replace?: boolean; redirect?: string } = {}) {
  return navegarEAguardarSaida(criarUrlLogin(redirect), { replace });
}

export function redirecionarParaLogout({ replace = false } = {}) {
  return navegarEAguardarSaida(criarUrlLogout(), { replace });
}

/**
 * O logout encerra a sessão da Área da Revenda e também a do Autenticador,
 * então quem apaga os cookies e redireciona é a própria API.
 */
export async function logout() {
  await logoutOfOldSite();
  await redirecionarParaLogout();
}

function criarUrlApi(caminho: string) {
  const base = env.VITE_API_URL.endsWith('/')
    ? env.VITE_API_URL
    : `${env.VITE_API_URL}/`;

  return new URL(caminho, base);
}

async function logoutOfOldSite() {
  try {
    const result = await fetch(createOldSiteRedirectUrl('logoff'), {
      credentials: 'include',
      mode: 'no-cors',
    });

    await result.text();
  } catch {
    // Se deu erro ao chamar o logoff do site antigo, não vamos impedir o logout do site novo.
  }
}
